/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCancelRoomInvitationRequestFromJSON(json) {
    return StreemApiCancelRoomInvitationRequestFromJSONTyped(json, false);
}
export function StreemApiCancelRoomInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canceledByUserSid': !exists(json, 'canceled_by_user_sid') ? undefined : json['canceled_by_user_sid'],
    };
}
export function StreemApiCancelRoomInvitationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'canceled_by_user_sid': value.canceledByUserSid,
    };
}
//# sourceMappingURL=StreemApiCancelRoomInvitationRequest.js.map